import React from 'react';
import { Search } from 'lucide-react';
import { Wheel } from '../../../../types';
import { LeadFilters } from '../hooks/useLeadsData';

interface LeadsFiltersProps {
  filters: LeadFilters;
  wheels: Wheel[];
  onFilterChange: (field: keyof LeadFilters, value: any) => void;
  onClearFilters: () => void;
}

const labelClass = 'block text-xs font-bold uppercase tracking-wider text-tinta mb-1.5';
const fieldClass =
  'block w-full bg-white border border-tinta/15 rounded-lg px-3 py-2.5 text-sm text-tinta placeholder:text-tinta-soft/70 placeholder:italic focus:outline-none focus:ring-2 focus:ring-bordo/40 focus:border-bordo transition-colors';

const LeadsFilters: React.FC<LeadsFiltersProps> = ({
  filters,
  wheels,
  onFilterChange,
  onClearFilters
}) => {
  return (
    <div className="bg-white border border-tinta/10 rounded-xl shadow-sm p-4">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
        <div>
          <label className={labelClass}>
            Buscar
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <Search className="h-4 w-4 text-tinta-soft" />
            </div>
            <input
              type="text"
              placeholder="Nome ou WhatsApp..."
              value={filters.search || ''}
              onChange={(e) => onFilterChange('search', e.target.value)}
              className={`${fieldClass} pl-10`}
            />
          </div>
        </div>

        <div>
          <label className={labelClass}>
            Sorteio
          </label>
          <select
            value={filters.wheel_id || ''}
            onChange={(e) => {
              const value = e.target.value;
              if (!value) {
                onFilterChange('wheel_id', undefined);
              } else if (value === 'manual') {
                onFilterChange('wheel_id', 'manual');
              } else {
                onFilterChange('wheel_id', parseInt(value));
              }
            }}
            className={fieldClass}
          >
            <option value="">Todos os sorteios</option>
            <option value="manual">Sorteio Manual</option>
            {wheels.map(wheel => (
              <option key={wheel.id} value={wheel.id}>
                {wheel.name}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className={labelClass}>
            Status
          </label>
          <select
            value={filters.won === undefined ? '' : filters.won.toString()}
            onChange={(e) => onFilterChange('won', e.target.value === '' ? undefined : e.target.value === 'true')}
            className={fieldClass}
          >
            <option value="">Todos</option>
            <option value="true">Ganharam</option>
            <option value="false">Não ganharam</option>
          </select>
        </div>

        <div>
          <label className={labelClass}>
            Aniversário
          </label>
          <select
            value={filters.is_birthday === undefined ? '' : filters.is_birthday.toString()}
            onChange={(e) => onFilterChange('is_birthday', e.target.value === '' ? undefined : e.target.value === 'true')}
            className={fieldClass}
          >
            <option value="">Todos os dias</option>
            <option value="true">Aniversariantes Hoje</option>
          </select>
        </div>

        <div>
          <label className={labelClass}>
            Data Inicial
          </label>
          <input
            type="date"
            value={filters.start_date || ''}
            onChange={(e) => onFilterChange('start_date', e.target.value)}
            className={fieldClass}
          />
        </div>

        <div>
          <label className={labelClass}>
            Data Final
          </label>
          <input
            type="date"
            value={filters.end_date || ''}
            onChange={(e) => onFilterChange('end_date', e.target.value)}
            className={fieldClass}
          />
        </div>
      </div>

      <div className="mt-4 flex justify-end">
        <button
          onClick={onClearFilters}
          className="text-sm font-bold text-bordo hover:text-bordo-dark transition-colors"
        >
          Limpar filtros
        </button>
      </div>
    </div>
  );
};

export default LeadsFilters;
